/* eslint-disable no-use-before-define */
import React from "react";
import PropTypes from "prop-types";
import ViewContainer from "../shared/ViewContainer";
import Header from "../shared/Header";
import UserThumb from "shared/components/UserThumb";
import Str from "shared/components/Str";
import _strf from "shared/util/_strf";
import _str from "shared/util/_str";

import { LikedVia } from "apps/messenger/components/Connections/constants";

import "apps/messenger/components/Connections/Prematch/IntroSplash.scss";

const getIntroBodyHeader = (likedVia, name) => {
	switch (likedVia) {
		case LikedVia.GLOBAL: {
			return _strf("You liked $name!", { name });
		}
		case LikedVia.ESSAY: {
			return _strf("You liked what $name wrote!", { name });
		}
		case LikedVia.PHOTO: {
			return _strf("You liked $name's photo!", { name });
		}
		default: {
			return _strf("You liked $name!", { name });
		}
	}
};

const getIntroBodySubtitle = (likedVia) => {
	switch (likedVia) {
		case LikedVia.GLOBAL: {
			return _str("Introduce yourself");
		}
		case LikedVia.ESSAY: {
			return _str("Add an intro to stand out");
		}
		case LikedVia.PHOTO: {
			return _str("Add an intro to stand out");
		}
		default: {
			return _str("You liked $name!");
		}
	}
};

const IntroSplash = ({
	username, thumbs, displayname, likedVia, onAddIntroClick, onClose
}) => {
	return (
		<div className="prematch-intro-splash">
			<ViewContainer onClose={onClose}>
				<div
					className="prematch-intro-splash-content"
				>
					<div
						className="prematch-intro-splash-content-thumb"
					>
						<UserThumb
							username={username}
							thumbs={thumbs}
							size="225x225"
							shape={UserThumb.displayTypes.Round}
						/>
					</div>
					<div
						className="prematch-intro-splash-content-body"
					>
						<Header>
							{ getIntroBodyHeader(likedVia, displayname) }
						</Header>
						<Header>
							{ getIntroBodySubtitle(likedVia) }
						</Header>
					</div>
					<button
						className="prematch-intro-splash-content-button"
						type="button"
						onClick={onAddIntroClick}
					>
						<Str>Add Intro</Str>
					</button>
				</div>
			</ViewContainer>
		</div>
	);
};

IntroSplash.propTypes = {
	username: PropTypes.string.isRequired,
	thumbs: PropTypes.array.isRequired,
	displayname: PropTypes.string.isRequired,
	likedVia: PropTypes.oneOf(Object.values(LikedVia)),
	onAddIntroClick: PropTypes.func.isRequired,
	onClose: PropTypes.func.isRequired,
};

IntroSplash.defaultProps = {
	likedVia: LikedVia.GLOBAL,
};

export default IntroSplash;



// WEBPACK FOOTER //
// ./src/apps/messenger/components/Connections/Prematch/IntroSplash.jsx